// Check localStorage for override, fallback to user preference
function getLocalOverride(key, defaultValue) {
  if (typeof window === 'undefined' || !window.localStorage) return defaultValue;
  const val = localStorage.getItem(key);
  if (val === 'true' || val === '1') return true;
  if (val === 'false' || val === '0') return false;
  return defaultValue;
}

export function getFeatureFlags(user) {
  return {
    clients: user?.feature_clients_enabled !== 0,
    shares: user?.feature_shares_enabled !== 0,
    friends: user?.feature_friends_enabled !== 0,
    strip: Number(user?.feature_strip_enabled) === 1,
    vault: ['pro', 'studio', 'business', 'agency'].includes(user?.subscription_tier),
    // Performance: use md thumbnails in grid, preload xl on hover for instant lightbox
    // Disable with: localStorage.setItem('fastThumbnails', 'false')
    fastThumbnails: getLocalOverride('fastThumbnails', true)
  };
}

export function toFeaturePayload(flags) {
  return {
    feature_clients_enabled: flags.clients ? 1 : 0,
    feature_shares_enabled: flags.shares ? 1 : 0,
    feature_friends_enabled: flags.friends ? 1 : 0,
    feature_strip_enabled: flags.strip ? 1 : 0
  };
}
